import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import { useTranslation } from "react-i18next";
import "./Style.css";
import Container from "Components/Container/Container";

const HeroSlider = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { t } = useTranslation();
  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
  };

  return (
    <div className=" bg-black pt-[10vh]">
      <Container>
        <div className="flex  items-center py-14">
          <h1 className="text-secondary text-4xl font-semibold">
            {t("our_projects")}
          </h1>
        </div>
      </Container>
      <Swiper
        slidesPerView={1}
        breakpoints={{
          578: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
        }}
        loop
        spaceBetween={20}
        navigation={true}
        modules={[Pagination, Navigation]}
        pagination={{
          clickable: true,
        }}
        className="  flex items-center gallery-slider  py-32"
        onSlideChange={handleSlideChange}
      >
        {data?.map((img, index) => {
          const isCentered = index === activeIndex + 1;
          return (
            <SwiperSlide className={""} key={index}>
              <div
                className={`relative transition ease-in duration-300 z-[0] ${
                  isCentered ? "z-[1000000000]  " : " z-[-10] "
                } ${index === activeIndex + 2 ? "relative z-[0]" : ""}`}
              >
                <img
                  className={`w-full h-[400px] lg:rounded-xl ${
                    isCentered ? "relative z-[1000]" : "relative z-[0]"
                  }`}
                  src={img}
                  alt=""
                />
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default HeroSlider;
